import { StyleSheet } from 'aphrodite/no-important';

import colors from '../../identity/colors';
import typeContent from '../../identity/type';
import screens from '../../identity/screenSizes';
import spacing from '../../identity/spacing';
import zindex from '../../identity/zIndex';

export default StyleSheet.create({
  footer: {
    background: colors.WHITE,
    position: 'fixed',
    bottom: 0,
    left: 0,
    height: spacing.FOOTER_HEIGHT,
    width: '100%',
    zIndex: zindex.footer,
    transform: 'translate3d(0,0,0)',  

    [screens.MOBILE]: { marginBottom: '80px' }, //TODO: paige remove after fade finished

  },

  a: {
    textDecoration: 'none',
  },

  content: {
    margin: '120px 60px',

    [screens.MOBILE]: { margin: '54px 27px' },
    [screens.DESKTOP_HD]: { margin: '132px' },
  },

  header: { 
    textDecoration: 'none',
    color: colors.GREY_NO_50,
    marginBottom: 60,

    ...typeContent.FOOTER,

  },

  h4: {
    ...typeContent.H4,
    color: colors.BLUE_SECONDARY,
    margin: 0,


    [screens.DESKTOP_HD]: { fontSize: '33px' },
  },


});


// WEBPACK FOOTER //
// ./src/components/Footer/styles.js